import React, { Fragment, useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import InformationalPopover from 'chameleon/ui-stack/ui/popovers/informational-popover';
import Context from 'chameleon-src/components/assign/AssignManageForm/Context';

/**
 * Renders the meta of a field: title & informational popover.
 * */
const FieldMeta = ({
  field: {
    isOptional,
    title: titleGetter,
    helpText,
    isHelpTextOpenedByDefault,
  },
  featureFlags,
}) => {
  const {
    isAssign,
    isPreApSubject,
    hasPreassignedBehavior,
    isFinalExam,
    isMCQPPC,
    individualStudentAssignmentFlag,
    isResourceForm,
    isSPP,
  } = useContext(Context);
  const title = titleGetter({
    isAssign,
    hasPreassignedBehavior,
    isFinalExam,
    individualStudentAssignmentFlag,
    isResourceForm,
  });

  const help =
    helpText &&
    helpText({
      isAssign,
      isPreApSubject,
      isFinalExam,
      isMCQPPC,
      individualStudentAssignmentFlag,
      isResourceForm,
      isSPP,
      featureFlags,
      allowHardTimer: featureFlags.allowHardTimer,
    });

  const popoverDefaultOpened =
    isHelpTextOpenedByDefault &&
    isHelpTextOpenedByDefault({
      isFinalExam,
      featureFlags,
    });

  return (
    <Fragment>
      <div className="ft-amf-title">
        {title}
        {isOptional && <span className="text-gray-500">&nbsp;(optional)</span>}
      </div>
      {help && (
        <div className="ft-amf-help">
          <InformationalPopover
            size="medium"
            defaultOpen={popoverDefaultOpened}
          >
            <span
              aria-live="assertive"
              aria-label={help}
              className="text-base leading-8"
            >
              {help}
            </span>
          </InformationalPopover>
        </div>
      )}
    </Fragment>
  );
};

FieldMeta.displayName = 'FieldMeta';

FieldMeta.propTypes = {
  /*
   * The data about the field to represent.
   * */
  field: PropTypes.shape({
    title: PropTypes.func.isRequired,
    helpText: PropTypes.func,
  }).isRequired,
};

const mapStateToProps = ({
  featureFlag: {
    assign_to_popover_default_opened: assignToPopoverDefaultOpened,
    scramble_questions_per_student: scrambleQuestionsPerStudent,
    review_mode: reviewModeFlag,
    allow_late_submission: allowLateSubmission,
    updated_timer_controls: allowHardTimer,
  },
}) => ({
  featureFlags: {
    assignToPopoverDefaultOpened,
    scrambleQuestionsPerStudent,
    reviewModeFlag,
    allowLateSubmission,
    allowHardTimer,
  },
});

export default connect(mapStateToProps)(FieldMeta);
